import ImageUploader from "@/components/admin/ImageUploader";
import ImageList from "@/components/admin/ImageList";
import { useRef } from "react";

interface ImageListRef {
  refresh: () => void;
}

const ImageUploadPage = () => {
  const imageListRef = useRef<ImageListRef>(null);

  const handleUploadSuccess = () => {
    if (imageListRef.current) {
      imageListRef.current.refresh();
    }
  };

  return (
    <div className="space-y-8">
      <h1 className="text-3xl font-bold text-primary">Képek Kezelése</h1>
      <ImageUploader onUploadSuccess={handleUploadSuccess} />
      <ImageList ref={imageListRef} />
    </div>
  );
};

export default ImageUploadPage;